import { Box } from "@mui/material"
import React from "react"

export type IHMHeroBlockProps = {
  children?: React.ReactNode
}

const IHMHeroBlock: React.FC<IHMHeroBlockProps> = ({ children }) => (
  <Box data-testid="HeroBlock" width="100%">
    {children}
  </Box>
)

export default IHMHeroBlock
